<template>
  <div>
    <div class="hide-dialog-header">
      <span>Confirmation</span>
    </div>
    <div class="hide-dialog-body">
      <span>Are you SURE you want to {{ action }} this {{ name }}?</span>
    </div>
    <div class="hide-dialog-footer">
      <button type="button" class="btn btn-secondary" @click="closeAction()">NO</button>
      <button type="button" class="btn btn-primary" @click="toggleAction()" :title="action">YES</button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Archive',
    props: {
      name: String,
      data: Object,
    },

    computed: {
      action () {
        return this.data  && this.data.active ? 'archive' : 'un-archive'
      }
    },

    methods: {
      toggleAction () {
        this.$emit('toggleAction')
      },

      closeAction () {
        this.$emit('closeAction')
      }
    }
  }
</script>

<style scoped>
  .hide-dialog-header {
    height: 35px;
    background-color: #2A95CC;
    padding: 8px;
    top: 0;
    color: white;
    font-weight: 700;
    font-size: 13px;
  }

  .hide-dialog-body {
    padding: 15px;
    font-weight: 600;
    font-size: 12px;
    text-align: center;
  }

  .hide-dialog-footer {
    height: 50px;
    width:100%;
    position:absolute;
    bottom: 0;
    padding: 7px;
    border-top: 1px solid #428bca;
  }

  .hide-dialog-footer button {
    margin-left: 9px;
    float: right;
    border-radius: 0px;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075) !important;
    padding: 3px 15px !important;
    font-size: 11px !important;
    font-weight: 500;
    margin-top: 10px !important;
  }
</style>
